export default __webpack_public_path__ + "static/media/levain.677be545.jpeg";